import React from "react";
import {
  FaTwitter,
  FaLinkedin,
  FaGithub,
  FaTelegramPlane,
  FaDiscord,
} from "react-icons/fa";
import styles from "./css/SocialLinks.module.css";

const defaultSocials = [
  { name: "Twitter", icon: <FaTwitter />, url: "#" },
  { name: "LinkedIn", icon: <FaLinkedin />, url: "#" },
  { name: "GitHub", icon: <FaGithub />, url: "#" },
  { name: "Telegram", icon: <FaTelegramPlane />, url: "#" },
  { name: "Discord", icon: <FaDiscord />, url: "#" },
];

const SocialLinks = ({ links = defaultSocials, className = "" }) => {
  return (
    <div className={`${styles.socialIconsContainer} ${className}`}>
      {links.map((item, idx) => (
        <a
          key={idx}
          href={item.url}
          className={styles.socialIcon}
          aria-label={item.name}
          target="_blank"
          rel="noopener noreferrer"
        >
          {item.icon}
        </a>
      ))}
    </div>
  );
};

export default SocialLinks;
